/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React from "react";
import { TweetyWidget } from "@vlinder-web/tweety-widget-react";
import { Container, Placeholder } from "react-bootstrap";

export interface ITriggerFormProps {
  triggerFields?: any;
  triggerLayout?: any;
  validatorConfig?: any;
  onTriggerSubmit?(data: any): void;
}
export const TriggerForm = (props: ITriggerFormProps) => {
  const {
    triggerFields,
    triggerLayout,
    validatorConfig,
    onTriggerSubmit
  } = props;

  const onTriggerPressSubmit = (data:any) => {
    console.log("The data passed here is : ", data);
    onTriggerSubmit && onTriggerSubmit(data);
  }

  return (
    <Container className="mb-5">
      <TweetyWidget
        fields={triggerFields}
        layout={triggerLayout}
        validatorConfig={validatorConfig}
        onFormSubmit={onTriggerPressSubmit}
      />
    </Container>
  );
};

// TriggerForm.defaultProps = {
//   triggerFields: [
//     {
//       type: "text", // TextInput for eventId
//       compProps: {
//         id: "eventId",
//         label: "Event ID",
//         required: true,
//         placeholder: "Enter Event ID",
//         errorText: "Event ID is required",
//       },
//     },
//     {
//       type: "select", // SelectInput for exposure (updated for correct dropdown rendering)
//       compProps: {
//         id: "exposure",
//         label: "Exposure",
//         required: true,
//         placeholder: "Select exposure level",
//         options: [
//           { id: "high", label: "High" },
//           { id: "moderate", label: "Moderate" },
//           { id: "low", label: "Low" }
//         ],
//         errorText: "Exposure is required",
//       },
//     },
//     {
//       type: "text", // TextInput for stormName
//       compProps: {
//         id: "stormName",
//         label: "Storm Name",
//         required: true,
//         placeholder: "Enter storm name",
//         errorText: "Storm name is required",
//       },
//     },
//     {
//       type: "number", // NumberInput for vmin
//       compProps: {
//         id: "vmin",
//         label: "Minimum Wind Speed (vmin)",
//         required: true,
//         placeholder: "Enter minimum wind speed",
//         errorText: "Minimum wind speed is required",
//       },
//     },
//     {
//       type: "number", // NumberInput for vmax
//       compProps: {
//         id: "vmax",
//         label: "Maximum Wind Speed (vmax)",
//         required: true,
//         placeholder: "Enter maximum wind speed",
//         errorText: "Maximum wind speed is required",
//         minValue: "vmin",  // Minimum value should be equal or higher than vmin
//       },
//     },
//     {
//       type: "datepicker", // DatePicker for date
//       compProps: {
//         id: "date",
//         label: "Event Date",
//         required: true,
//         placeholder: "Select the event date",
//         errorText: "Event date is required",
//       },
//     },
//     {
//       type: "countrySelect", // CountrySelectInput for country
//       compProps: {
//         id: "country",
//         label: "Country",
//         required: true,
//         placeholder: "Select your country",
//         errorText: "Country is required",
//       },
//     },
//     {
//       type: "select", // SelectInput for category (updated for correct dropdown rendering)
//       compProps: {
//         id: "category",
//         label: "Category",
//         required: true,
//         placeholder: "Select cyclone category",
//         options: [
//           { id: "category1", label: "Category 1" },
//           { id: "category2", label: "Category 2" },
//           { id: "category3", label: "Category 3" },
//           { id: "category4", label: "Category 4" },
//           { id: "category5", label: "Category 5" },
//           { id: "category6", label: "Category 6" }
//         ],
//         errorText: "Cyclone category is required",
//       },
//     },
//     {
//       type: "select", // SelectInput for status (updated for correct dropdown rendering)
//       compProps: {
//         id: "status",
//         label: "Status",
//         required: true,
//         placeholder: "Select cyclone status",
//         options: [
//           { id: "OCCURRED", label: "Occurred" },
//           { id: "INVALID", label: "Invalid" },
//           { id: "ACTIVE", label: "Active" },
//           { id: "IN_QUEUE", label: "In Queue" },
//           { id: "ACCEPTED", label: "Accepted" },
//           { id: "REJECTED", label: "Rejected" },
//           { id: "CLOSED", label: "Closed" },
//           { id: "PAYOUT_CALCULATION_INPROCESS", label: "Payout Calculation In Process" }
//         ],
//         errorText: "Cyclone status is required",
//       },
//     },
//     {
//       type: "text", // TextInput for reason
//       compProps: {
//         id: "reason",
//         label: "Reason",
//         required: false,
//         placeholder: "Enter reason",
//         errorText: "Reason is required",
//       },
//     },
//     {
//       type: "text", // TextInput for payoutEstimate
//       compProps: {
//         id: "payoutEstimate",
//         label: "Payout Estimate",
//         required: false,
//         placeholder: "Enter payout estimate",
//         errorText: "Payout estimate is required",
//       },
//     },
//     {
//       type: "number", // NumberInput for payoutEstimateRaw
//       compProps: {
//         id: "payoutEstimateRaw",
//         label: "Payout Estimate (Raw)",
//         required: false,
//         placeholder: "Enter raw payout estimate",
//         errorText: "Payout estimate raw is required",
//       },
//     },
//     {
//       type: "text", // TextInput for blockchainTxnHash
//       compProps: {
//         id: "blockchainTxnHash",
//         label: "Blockchain Transaction Hash",
//         required: false,
//         placeholder: "Enter blockchain transaction hash",
//         errorText: "Blockchain transaction hash is required",
//       },
//     },
//   ],
  
//   triggerLayout: [
//     ["eventId", "stormName"], 
//     ["vmin", "vmax"], 
//     ["date", "country"],
//     ["exposure", "category", "status"], 
//     ["payoutEstimate", "reason"], 
//     // ["blockchainTxnHash", "payoutEstimateRaw"]
//   ],

//   validatorConfig: {
//     ruleSets: [
//       {
//         fields: {
//           eventId: [
//             {
//               type: "REQUIRED",
//               errorMessage: "Event ID is required",
//             },
//           ],
//           exposure: [
//             {
//               type: "REQUIRED",
//               errorMessage: "Exposure is required",
//             },
//           ],
//           stormName: [
//             {
//               type: "REQUIRED",
//               errorMessage: "Storm name is required",
//             },
//           ],
//           vmin: [
//             {
//               type: "REQUIRED",
//               errorMessage: "Minimum wind speed is required",
//             },
//           ],
//           vmax: [
//             {
//               type: "REQUIRED",
//               errorMessage: "Maximum wind speed is required",
//             },
//             {
//               type: "MINVALUE",
//               minValue: "vmin",
//               errorMessage: "Maximum wind speed should be greater than or equal to minimum wind speed",
//             },
//           ],
//           date: [
//             {
//               type: "REQUIRED",
//               errorMessage: "Date is required",
//             },
//           ],
//           country: [
//             {
//               type: "REQUIRED",
//               errorMessage: "Country is required",
//             },
//           ],
//           category: [
//             {
//               type: "REQUIRED",
//               errorMessage: "Category is required",
//             },
//           ],
//           status: [
//             {
//               type: "REQUIRED",
//               errorMessage: "Status is required",
//             },
//           ],
//           payoutEstimate: [
//             {
//               type: "REQUIRED",
//               errorMessage: "Payout estimate is required",
//             },
//           ],
//           payoutEstimateRaw: [
//             {
//               type: "REQUIRED",
//               errorMessage: "Payout estimate raw value is required",
//             },
//           ],
//         },
//       },
//     ],
//   },
// };
